/*
  Data Management State - Getters.
*/

import * as entityUtils from '@/core/utils/entityUtils';

/* ---------------------------------------------------------- */
// Feature flags.

/**
 * Determine whether 4th Version is enabled.
 * @returns True if AppState.isFourthVersion is set.
 */
const isFourthVersion = (rootState) => {
  return !!rootState.app.isFourthVersion ? true : false;
};

/**
 * Data Management Component configuration.
 * @returns { bool } [bool] true if the Field Calculation modal is allowed in this instance.
 */
export function fieldCalculationModalSupported(state, getters, rootState) {
  /* Calculation Modal originally intended to be v4 dependent, but this is not possible given that the corresponding functionality has been stripped from the Field modal. */
  return true /*isFourthVersion(rootState)*/;
};

/**
 * Data Management Component configuration.
 * @param { String } calculationType to be verified.
 * @returns { bool } [bool] Flag to indicate whether  the Calculation Type is active.
 */
export function fieldCalculationTypeAllowed(state, getters, rootState, rootGetters) {
  return (calculationType) => {
    // Check if Field Calculation modal is allowed (should always be).
    if (!getters.fieldCalculationModalSupported) return false;
    // Some Calculation Types are controlled by Feature Flag.
    const featureFlagNames = rootState.systemInfo.systemSettings.featureFlagNames;
    let featureFlagName = '';
    switch (calculationType) {
      case entityUtils.calculationTypes.concatenation:
        break;
      case entityUtils.calculationTypes.RowFormula:
        featureFlagName = featureFlagNames.fieldCalc_RowFormula;
        break;
      case entityUtils.calculationTypes.Aggregation:
        featureFlagName = featureFlagNames.fieldCalc_Aggregation;
        break;
      case entityUtils.calculationTypes.MdmAggregation:
        featureFlagName = featureFlagNames.fieldCalc_MdmAggregation;
        break;
      case entityUtils.calculationTypes.lookup:
        break;
      case entityUtils.calculationTypes.AIChat:
        featureFlagName = featureFlagNames.fieldCalc_AIChat;
        break;
      default:
        return false;
    }
    if (featureFlagName && !rootGetters['systemInfo/getFeatureFlagValue'](featureFlagName))
      return false;
    return true;
  };
};

/* ---------------------------------------------------------- */

/**
 * Get Field Types as {text,value} to populate dropdown.
 * @param { DataManagementState } state
 * @return { array }
 */
export function fieldTypes(state) {
  return [{ text: '-- Field Type --', value: '', disabled: true }, ...state.fieldTypes];
}

export function fields(state) {
  return state.table.schema.fields.map(f => ({ ...f, key: f.name, sortable: true }));
}

export function fieldValueTypes(state) {
  return state.fieldValues;

}

export function tableSchema(state) {
  return state.table;
}

export function isAdmin(state) {
  return state.currentUserPermission === 'admin';
}

export function selectedMDMView(state) {
  return state.table.views.find(v => v.isSelected) || { viewGuid: '' };
}

export function getAllFields(state) {
  return state.allFields;
}

export function getCurrentFolder(state) {
  return state.currentFolder;
}

/* ---------------------------------------------------------- */
